module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('strong', [_vm._v("RACE, RELIGION, AND ETHNICITY"), _c('br'), _vm._v("General Editor: Peter J. Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Public Religion and Urban Transformation:"), _c('br'), _vm._v("Faith in the City")]), _c('br'), _vm._v("Edited by Lowell W. Livezey")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Down by the Riverside:"), _c('br'), _vm._v("Readings in African American Religion")]), _c('br'), _vm._v("Edited by Larry G. Murphy")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("New York Glory:"), _c('br'), _vm._v("Religions in the City")]), _c('br'), _vm._v("Edited by Tony Carnes and Anna Karpathakis")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Religion and the Creation of Race and Ethnicity"), _c('br'), _vm._v("An Introduction")]), _c('br'), _vm._v("Edited by Craig R. Prentiss")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599bda9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0